import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase, updatePerfil } from '../../lib/supabase'
import { useAuth } from '../../contexts/AuthContext'
import { useTenant } from '../../contexts/TenantContext'

function validarPassword(password) {
  const erros = []
  if (password.length < 8) erros.push('Mínimo 8 caracteres')
  if (!/[A-Z]/.test(password)) erros.push('Pelo menos uma letra maiúscula')
  if (!/[0-9]/.test(password)) erros.push('Pelo menos um número')
  return erros
}

export default function AlterarPassword() {
  const [password, setPassword] = useState('')
  const [confirmar, setConfirmar] = useState('')
  const [erro, setErro] = useState('')
  const [carregando, setCarregando] = useState(false)
  const { utilizador, recarregarPerfil } = useAuth()
  const { tenant } = useTenant()
  const navigate = useNavigate()

  const errosPassword = validarPassword(password)
  const passwordValida = errosPassword.length === 0
  const coincide = password === confirmar

  async function handleSubmit(e) {
    e.preventDefault()
    setErro('')
    if (!passwordValida) return
    if (!coincide) { setErro('As palavras-passe não coincidem.'); return }

    setCarregando(true)
    try {
      const { error: erroPwd } = await supabase.auth.updateUser({ password })
      if (erroPwd) throw new Error('password: ' + erroPwd.message)

      await updatePerfil(tenant.id, utilizador.id, { forcar_mudanca_password: false })

      await recarregarPerfil()
      navigate('/admin')
    } catch (e) {
      setErro('Erro: ' + e.message)
    } finally {
      setCarregando(false)
    }
  }

  return (
    <main style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--cor-creme)',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '40px',
        width: '100%',
        maxWidth: '380px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
      }}>
        <h1 style={{ fontSize: '22px', marginBottom: '6px', color: 'var(--cor-texto)' }}>
          Definir palavra-passe
        </h1>
        <p style={{ fontSize: '14px', color: 'var(--cor-texto-suave)', marginBottom: '28px' }}>
          É necessário definir uma nova palavra-passe para continuar.
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>
              Nova palavra-passe
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="new-password"
              style={{
                width: '100%',
                padding: '10px 12px',
                border: `1px solid ${password && !passwordValida ? '#c0392b' : 'var(--cor-borda)'}`,
                borderRadius: '8px',
                fontSize: '14px',
                boxSizing: 'border-box',
              }}
            />
            {password && errosPassword.length > 0 && (
              <ul style={{ margin: '6px 0 0', padding: '0 0 0 16px', fontSize: '12px', color: '#c0392b' }}>
                {errosPassword.map(e => <li key={e}>{e}</li>)}
              </ul>
            )}
            {password && passwordValida && (
              <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#27ae60' }}>Palavra-passe válida</p>
            )}
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>
              Confirmar palavra-passe
            </label>
            <input
              type="password"
              value={confirmar}
              onChange={e => setConfirmar(e.target.value)}
              required
              autoComplete="new-password"
              style={{
                width: '100%',
                padding: '10px 12px',
                border: `1px solid ${confirmar && !coincide ? '#c0392b' : 'var(--cor-borda)'}`,
                borderRadius: '8px',
                fontSize: '14px',
                boxSizing: 'border-box',
              }}
            />
            {confirmar && !coincide && (
              <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#c0392b' }}>As palavras-passe não coincidem</p>
            )}
          </div>

          {erro && (
            <p role="alert" style={{ color: '#c0392b', fontSize: '13px', marginBottom: '16px' }}>
              {erro}
            </p>
          )}

          <button
            type="submit"
            disabled={carregando || !passwordValida || !coincide}
            className="btn-primario"
            style={{ width: '100%', justifyContent: 'center' }}
          >
            {carregando ? 'A guardar…' : 'Guardar e entrar'}
          </button>
        </form>
      </div>
    </main>
  )
}
